import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Commons from "../../Services/Common/Common";
/** Styles Import */
import "./Style.css";
/** Components Import */
import { Form } from "react-bootstrap";
import AutoTranslate from "../../Components/AutoTranslate";

const Business = ({ userId = "", setUserId = (e) => {}, userPassword = "", setUserPassword = (e) => {}, HandleSubmit = (e) => {} }) => {
  const language = useSelector((state) => state.localStorage.language);
  return (
    <React.Fragment>
      <Form.Group className='mb-3' controlId='username'>
        <Form.Label>
          <AutoTranslate targetLanguage={language.lang}>아이디</AutoTranslate>
        </Form.Label>
        <Form.Control type='text' value={userId} onChange={(e) => setUserId(e.target.value)} onClick={(e) => e.target.select()} required autoFocus />
      </Form.Group>
      <Form.Group className='mb-4' controlId='password'>
        <Form.Label>
          <AutoTranslate targetLanguage={language.lang}>비밀번호</AutoTranslate>
        </Form.Label>
        <Form.Control
          type='password'
          value={userPassword}
          onChange={(e) => setUserPassword(e.target.value)}
          onClick={(e) => e.target.select()}
          onKeyUp={(e) => e.key === "Enter" && HandleSubmit(e)}
          required
        />
      </Form.Group>
    </React.Fragment>
  );
};

export default Business;
